import React, { useState } from "react";
import {Button, Form, Input, Modal, Tag} from "antd";
import {LockOutlined} from "@ant-design/icons";


const ChangePasswordModal = ({ changePassowrd, item, buttonType, text }) => {
    const [visible, setVisible] = useState(false);
    const [form] = Form.useForm();
    const handleChangePassword = (values) => {
        // console.log("Form values:", values);
        changePassowrd(item, values.newPassword); // Pass the item to the changePassowrd handler
        setVisible(false); // Close the modal after delete action
    };

    const showModal = () => {
        setVisible(true);
    };

    const handleCancel = () => {
        setVisible(false);
    };

    return (
        <>
            <Button type={buttonType || "link"} onClick={showModal}>
                {text || "Change password"}
            </Button>
            <Modal
                title={<>Change Password <Tag>{item.fullName}</Tag></>}
                visible={visible}
                onCancel={handleCancel}
                cancelText="Cancel"
                footer={null}
            >

                <Form
                    form={form}
                    name="changePassword"
                    onFinish={handleChangePassword}
                    layout="vertical"
                    autoComplete="off"
                >

                    <Form.Item
                        name="newPassword"
                        label="New Password"
                        rules={[
                            {required: true, message: "Please enter your new password"},
                            {min: 6, message: "Password must be at least 6 characters"},
                        ]}
                        hasFeedback
                    >
                        <Input.Password
                            prefix={<LockOutlined/>}
                            placeholder="Enter new password"
                        />
                    </Form.Item>

                    <Form.Item
                        name="confirmPassword"
                        label="Confirm New Password"
                        dependencies={["newPassword"]}
                        hasFeedback
                        rules={[
                            {required: true, message: "Please confirm your new password"},
                            ({getFieldValue}) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue("newPassword") === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error("Passwords do not match"));
                                },
                            }),
                        ]}
                    >
                        <Input.Password
                            prefix={<LockOutlined/>}
                            placeholder="Confirm new password"
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" block>
                            Change Password
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default ChangePasswordModal;
